import {Box} from "@mui/material";
import config from "../../../../config";
import {CopyToClipboard} from "react-copy-to-clipboard/src";
import Copy from "@assets/images/icons/copy.svg";
import React from "react";

export const UserItem = ({data}) => {
  const {
    display_id,
    created_at,
    country,
    fd_sum,
    fd_created_at,
    deposits_count,
    deposits_sum,
    withdrawals,
    balance,
    partner_profit,
    affiliate_link_hash,
    affiliate_link_offer,
    campaign_name
  } = data;

  return (<div className="table__tr">
    <Box
      sx={{
        flex: "1 0 240px",
      }}
      className="table__td"
    >
      <p
        className="table__text table__id table__text--blue">{created_at}</p>
      <p className="table__text">{display_id}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{country}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{fd_sum} $</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{fd_created_at}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{deposits_count}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{deposits_sum} $</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{withdrawals}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 85px",
      }}
      className="table__td"
    >
      <p className="table__text">{balance} $</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{partner_profit} $</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 160px",
      }}
      className="table__td"
    >
      <div className="table__wrap">
        <a target="_blank" href={`${config.app_url}/p/${affiliate_link_hash}?target=register`}
           className="table__text table__text--blue">{`${config.app_url}/p/${affiliate_link_hash}?target=register`}</a>
        <CopyToClipboard text={`${config.app_url}/p/${affiliate_link_hash}?target=register`}>
          <button type="button" className="table__copy">
            <img src={Copy}/>
          </button>
        </CopyToClipboard>
      </div>
    </Box>
    {/*<Box*/}
    {/*  sx={{*/}
    {/*    flex: "1 0 120px",*/}
    {/*  }}*/}
    {/*  className="table__td"*/}
    {/*>*/}
    {/*  <p className="table__text">{profit}</p>*/}
    {/*</Box>*/}
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{affiliate_link_offer}</p>
    </Box>
    <Box
      sx={{
        flex: "1 0 120px",
      }}
      className="table__td"
    >
      <p className="table__text">{campaign_name}</p>
    </Box>
  </div>)
}